document.addEventListener('DOMContentLoaded', () => {
    const contentPage = document.querySelector('.content-page');
    const articleIntro = document.querySelector('.full-article div');

    if (!contentPage.classList.contains('section') && !contentPage.classList.contains('article')) {
        return;
    }
    if (articleIntro) {
        const aside = document.querySelector('.content-aside');
        if (!articleIntro || !aside) return;

        aside.innerHTML = articleIntro.innerHTML;
        articleIntro.remove();
    }

    const articlesNav = document.querySelector('.next-prev');
    if (articlesNav?.children.length < 2 && [...articlesNav.children].some((child) => child.classList.contains('next'))) {
        articlesNav.classList.add('single');
    }

    const accordion = document.querySelector('.block-accordion');
    const articlesLists = document.querySelectorAll('.articles-lists');
    if (accordion == null && articlesLists.length === 0) {
        const leftCol = document.querySelector('.content-left-col');
        if (leftCol) {
            leftCol.style.display = 'none';
        }
    }
});
